import Collapse from '@material-ui/core/Collapse'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import InputAdornment from '@material-ui/core/InputAdornment'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet'
import AccountTreeIcon from '@material-ui/icons/AccountTree'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import AssessmentIcon from '@material-ui/icons/Assessment'
import BusinessIcon from '@material-ui/icons/Business'
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter'
import DashboardIcon from '@material-ui/icons/Dashboard'
import DescriptionIcon from '@material-ui/icons/Description'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty'
import MenuIcon from '@material-ui/icons/Menu'
import NoteAddIcon from '@material-ui/icons/NoteAdd'
import PeopleIcon from '@material-ui/icons/People'
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar'
import ReceiptIcon from '@material-ui/icons/Receipt'
import SearchIcon from '@material-ui/icons/Search'
import SettingsIcon from '@material-ui/icons/Settings'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'
import TurnedInIcon from '@material-ui/icons/TurnedIn'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import {
	setIsMenuDrawerBudgetingOpen,
	setIsMenuDrawerExpensesOpen,
	setIsMenuDrawerOpen,
	setIsMenuDrawerRevenuesOpen,
} from 'src/redux/slices/settings'
import { useFetchUserInfoQuery } from '@/redux/api/graphql/userInfoApi'
import ChedarLogo from '../../../assets/images/ChedarMenuIconSmall.png'

const useStyles = makeStyles((theme) => ({
	list: {
		width: 270,
	},
	text: {
		'& span': {
			fontSize: '1rem',
			letterSpacing: '0.1rem',
		},
	},
	fullList: {
		width: 'auto',
	},
	backArrow: {
		color: '#364263',
		backgroundColor: 'lightgray',
		border: '1px solid lightgray',
		borderRadius: '4px',
		cursor: 'pointer',
		'&:hover': {
			color: 'white',
			backgroundColor: '#364263',
		},
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		margin: '0.5rem 1rem 0',
	},
	searchBar: {
		margin: '1rem 1rem 0 ',
	},
	divider: {
		margin: '1rem 0.7rem ',
	},

	icon: {
		minWidth: 0,
		marginRight: '0.5rem',
		color: '#364263',
	},
	links: {
		paddingLeft: '2rem',
		color: '#364263',
		'&:hover': {
			backgroundColor: '#364263',
			color: 'white',
			'& svg': {
				color: 'white',
			},
		},
	},
	nested: {
		paddingLeft: theme.spacing(6),
		color: '#364263',
		'&:hover': {
			backgroundColor: '#364263',
			color: 'white',
			'& svg': {
				color: 'white',
			},
		},
	},
}))

export default function MenuDrawer({ userLoginStatus, isFreelancer }) {
	const classes = useStyles()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { t } = useTranslation()
	const { t: tMenuDrawer } = useTranslation('MenuDrawer')
	const { t: tInvoices } = useTranslation('invoices')
	const [open, setOpen] = useState(false)
	const isMenuDrawerOpen = useSelector(
		(state) => state.settings.isMenuDrawerOpen
	)
	const userInfoId = useSelector((state) => state.auth.userInfo?.id)
	const companyInfo = useSelector((state) => state.settings.companyInfo)

	const { data: userInfo } = useFetchUserInfoQuery(
		{
			userInfoId: userInfoId,
		},
		{
			skip: !userInfoId,
		}
	)

	const isMenuDrawerBudgetingOpen = useSelector(
		(state) => state.settings.isMenuDrawerBudgetingOpen
	)
	const isMenuDrawerExpensesOpen = useSelector(
		(state) => state.settings.isMenuDrawerExpensesOpen
	)
	const isMenuDrawerRevenuesOpen = useSelector(
		(state) => state.settings.isMenuDrawerRevenuesOpen
	)
	const isCompanyAdmin = userInfo?.cognitoGroup?.includes('companyAdmin')
	const isSuperUser = userInfo?.cognitoGroup?.includes('companySuperUser')
	const isTeamAdmin = userInfo?.cognitoGroup?.includes('teamAdmin')
	const isSubTeamAdmin = userInfo?.cognitoGroup?.includes('subTeamAdmin')
	const isTeamOrSubTeamAdmin = isTeamAdmin || isSubTeamAdmin

	const [openDropdown, setOpenDropdown] = useState({
		expenseManagement: false,
		supplierInvoices: false,
		expenses: false,
		revenues: false,
		accounting: false,
		support: false,
		settings: false,
		budget: false,
	})

	const handleClick = (event, name) => {
		console.log('name: ', name)
		event.stopPropagation()
		setOpenDropdown({ ...openDropdown, [name]: !openDropdown[name] })
	}

	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return
		}

		setOpen(open)
		dispatch(setIsMenuDrawerOpen(false))
		dispatch(setIsMenuDrawerBudgetingOpen(false))
		dispatch(setIsMenuDrawerExpensesOpen(false))
		dispatch(setIsMenuDrawerRevenuesOpen(false))
		// setOpenDropdown(false)
	}

	const companyAdminList = () => (
		<div
			className={classes.list}
			role="presentation"
			onClick={toggleDrawer('left', false)}
			onKeyDown={toggleDrawer('left', false)}
		>
			<List>
				<ListItem
					button
					className={classes.links}
					onClick={() => navigate('/dashboard')}
					disabled={!isSuperUser}
					data-testid="dashboard-link"
				>
					<ListItemIcon className={classes.icon}>
						<DashboardIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('dashboard')}
					/>
				</ListItem>
				<Divider className={classes.divider} />
				<div className="menuDrawerBudgeting">
					<ListItem
						button
						style={{ paddingLeft: '2rem', marginTop: '1rem' }}
						onClick={(event) => handleClick(event, 'budget')}
					>
						<ListItemText
							className={classes.text}
							primary={tMenuDrawer('budget')}
						/>
						{openDropdown?.budget || isMenuDrawerBudgetingOpen ? (
							<ExpandLess />
						) : (
							<ExpandMore />
						)}
					</ListItem>
					<Collapse
						in={openDropdown?.budget || isMenuDrawerBudgetingOpen}
						timeout="auto"
						unmountOnExit
					>
						<List component="div" disablePadding>
							<ListItem
								button
								className={classes.nested}
								onClick={() => navigate('/')}
							>
								<ListItemIcon className={classes.icon}>
									<PeopleIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('teamView')}
								/>
							</ListItem>
							<ListItem
								button
								className={classes.nested}
								onClick={() => navigate('/quotelist')}
							>
								<ListItemIcon className={classes.icon}>
									<AccountBalanceWalletIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('quotelist')}
								/>
							</ListItem>
							{(isCompanyAdmin || isTeamAdmin) && (
								<ListItem
									button
									className={classes.nested}
									onClick={() => navigate('/companyTemplate')}
								>
									<ListItemIcon className={classes.icon}>
										<TurnedInIcon fontSize="small" />
									</ListItemIcon>
									<ListItemText
										className={classes.text}
										primary={tMenuDrawer('companyTemplate')}
									/>
								</ListItem>
							)}
							<ListItem
								button
								className={classes.nested}
								onClick={() => navigate('/projectlist')}
							>
								<ListItemIcon className={classes.icon}>
									<AccountTreeIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('projectlist')}
								/>
							</ListItem>
						</List>
					</Collapse>
					<Divider className={classes.divider} />
				</div>
				<div className="menuDrawerExpenses">
					<ListItem
						button
						style={{ paddingLeft: '2rem', marginTop: '1rem' }}
						onClick={(event) =>
							handleClick(event, 'expenseManagement')
						}
					>
						<ListItemText
							className={classes.text}
							primary={tMenuDrawer('expenseManagement')}
						/>
						{openDropdown?.expenseManagement ||
						isMenuDrawerExpensesOpen ? (
							<ExpandLess />
						) : (
							<ExpandMore />
						)}
					</ListItem>
					<Collapse
						in={
							openDropdown?.expenseManagement ||
							isMenuDrawerExpensesOpen
						}
						timeout="auto"
						unmountOnExit
					>
						<List component="div" disablePadding>
							<ListItem
								button
								className={classes.links}
								onClick={() => navigate('/suppliers')}
							>
								<ListItemIcon className={classes.icon}>
									<BusinessIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('suppliers')}
								/>
							</ListItem>
							<ListItem
								button
								className={classes.links}
								onClick={() => navigate('/purchases')}
							>
								<ListItemIcon className={classes.icon}>
									<ShoppingBasketIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('purchases')}
								/>
							</ListItem>
							<ListItem
								button
								className={classes.links}
								onClick={() => navigate('/supplierInvoices')}
							>
								<ListItemIcon className={classes.icon}>
									<NoteAddIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('supplierInvoices')}
								/>
							</ListItem>
						</List>
					</Collapse>
				</div>
				<Divider className={classes.divider} />
				<div className="menuDrawerRevenues">
					<ListItem
						button
						style={{ paddingLeft: '2rem', marginTop: '1rem' }}
						onClick={(event) => handleClick(event, 'revenues')}
					>
						<ListItemText
							className={classes.text}
							primary={tMenuDrawer('revenues')}
						/>
						{openDropdown?.revenues || isMenuDrawerRevenuesOpen ? (
							<ExpandLess />
						) : (
							<ExpandMore />
						)}
					</ListItem>
					<Collapse
						in={openDropdown?.revenues || isMenuDrawerRevenuesOpen}
						timeout="auto"
						unmountOnExit
					>
						<List component="div" disablePadding>
							<ListItem
								button
								className={classes.links}
								onClick={() => navigate('/contacts')}
							>
								<ListItemIcon className={classes.icon}>
									<PermContactCalendarIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('clients')}
								/>
							</ListItem>
							<ListItem
								button
								className={classes.links}
								onClick={() => navigate('/proposals')}
							>
								<ListItemIcon className={classes.icon}>
									<BusinessCenterIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('proposals')}
								/>
							</ListItem>
							<ListItem
								button
								className={classes.links}
								onClick={() => navigate('/invoices')}
							>
								<ListItemIcon className={classes.icon}>
									<DescriptionIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tInvoices('invoices')}
								/>
							</ListItem>
						</List>
					</Collapse>
				</div>
				<Divider className={classes.divider} />
				<ListItem
					button
					className={classes.links}
					onClick={() => navigate('/banking')}
					disabled={!isSuperUser}
				>
					<ListItemIcon className={classes.icon}>
						<AccountBalanceIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('banking')}
					/>
				</ListItem>
				<Divider className={classes.divider} />
				<ListItem
					button
					className={classes.links}
					onClick={() => navigate('/reporting')}
					disabled={!isSuperUser}
				>
					<ListItemIcon className={classes.icon}>
						<AssessmentIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary="Reporting"
					/>
				</ListItem>
				<Divider className={classes.divider} />

				<ListItem
					button
					style={{ paddingLeft: '2rem', marginTop: '1rem' }}
					onClick={(event) => handleClick(event, 'settings')}
				>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('settings')}
					/>
					{openDropdown?.settings ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse
					in={openDropdown?.settings}
					timeout="auto"
					unmountOnExit
				>
					<List component="div" disablePadding>
						<ListItem
							button
							className={classes.links}
							onClick={() => navigate('/accountSettings')}
						>
							<ListItemIcon className={classes.icon}>
								<SettingsIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('accountSettings')}
							/>
						</ListItem>
						<ListItem
							button
							className={classes.links}
							onClick={() => navigate('/teamsettings')}
						>
							<ListItemIcon className={classes.icon}>
								<SettingsIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('teamSettings')}
							/>
						</ListItem>
						<ListItem
							button
							className={classes.links}
							onClick={() => navigate('/billing')}
						>
							<ListItemIcon className={classes.icon}>
								<ReceiptIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('billing')}
							/>
						</ListItem>
					</List>
				</Collapse>
				<Divider className={classes.divider} />
			</List>
		</div>
	)

	const freelancerList = () => (
		<div
			className={classes.list}
			role="presentation"
			onClick={toggleDrawer('left', false)}
			onKeyDown={toggleDrawer('left', false)}
		>
			<List>
				<ListItem
					button
					className={classes.links}
					onClick={() => navigate('/')}
				>
					<ListItemIcon className={classes.icon}>
						<AccountBalanceWalletIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('budget')}
					/>
				</ListItem>
				<Divider className={classes.divider} />
				<ListItem
					button
					className={classes.links}
					onClick={() => navigate('/supplierInvoices')}
				>
					<ListItemIcon className={classes.icon}>
						<HourglassEmptyIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('supplierInvoices')}
					/>
				</ListItem>
				<Divider className={classes.divider} />
				<ListItem
					button
					className={classes.links}
					onClick={() => navigate('/purchases')}
				>
					<ListItemIcon className={classes.icon}>
						<ShoppingBasketIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('purchases')}
					/>
				</ListItem>
			</List>
		</div>
	)

	const teamAdminList = () => (
		<div
			className={classes.list}
			role="presentation"
			onClick={toggleDrawer('left', false)}
			onKeyDown={toggleDrawer('left', false)}
		>
			<List>
				<ListItem
					button
					className={classes.links}
					onClick={() => navigate('/dashboard')}
					disabled={!isSuperUser}
					data-testid="dashboard-link"
				>
					<ListItemIcon className={classes.icon}>
						<DashboardIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('dashboard')}
					/>
				</ListItem>
				<Divider className={classes.divider} />
				<ListItem
					button
					style={{ paddingLeft: '2rem', marginTop: '1rem' }}
					onClick={(event) => handleClick(event, 'budget')}
				>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('budget')}
					/>
					{openDropdown?.budget ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse
					in={openDropdown?.budget}
					timeout="auto"
					unmountOnExit
				>
					<List component="div" disablePadding>
						<ListItem
							button
							className={classes.nested}
							onClick={() => navigate('/')}
						>
							<ListItemIcon className={classes.icon}>
								<PeopleIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('teamView')}
							/>
						</ListItem>
						<ListItem
							button
							className={classes.nested}
							onClick={() => navigate('/quotelist')}
						>
							<ListItemIcon className={classes.icon}>
								<AccountBalanceWalletIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('quotelist')}
							/>
						</ListItem>
						{(isCompanyAdmin || isTeamAdmin) && (
							<ListItem
								button
								className={classes.nested}
								onClick={() => navigate('/companyTemplate')}
							>
								<ListItemIcon className={classes.icon}>
									<TurnedInIcon fontSize="small" />
								</ListItemIcon>
								<ListItemText
									className={classes.text}
									primary={tMenuDrawer('companyTemplate')}
								/>
							</ListItem>
						)}
						<ListItem
							button
							className={classes.nested}
							onClick={() => navigate('/projectlist')}
						>
							<ListItemIcon className={classes.icon}>
								<AccountTreeIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('projectlist')}
							/>
						</ListItem>
					</List>
				</Collapse>
				<Divider className={classes.divider} />
				<ListItem
					button
					style={{ paddingLeft: '2rem', marginTop: '1rem' }}
					onClick={(event) => handleClick(event, 'expenseManagement')}
				>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('expenseManagement')}
					/>
					{openDropdown?.expenseManagement ? (
						<ExpandLess />
					) : (
						<ExpandMore />
					)}
				</ListItem>
				<Collapse
					in={openDropdown?.expenseManagement}
					timeout="auto"
					unmountOnExit
				>
					<List component="div" disablePadding>
						<ListItem
							button
							className={classes.links}
							onClick={() => navigate('/suppliers')}
						>
							<ListItemIcon className={classes.icon}>
								<BusinessIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('suppliers')}
							/>
						</ListItem>
						<ListItem
							button
							className={classes.links}
							onClick={() => navigate('/purchases')}
						>
							<ListItemIcon className={classes.icon}>
								<ShoppingBasketIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('purchases')}
							/>
						</ListItem>
						<ListItem
							button
							className={classes.links}
							onClick={() => navigate('/supplierInvoices')}
						>
							<ListItemIcon className={classes.icon}>
								<NoteAddIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('supplierInvoices')}
							/>
						</ListItem>
					</List>
				</Collapse>
				<Divider className={classes.divider} />
				<ListItem
					button
					style={{ paddingLeft: '2rem', marginTop: '1rem' }}
					disabled
				>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('revenues')}
					/>
					{openDropdown?.revenues ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse
					in={openDropdown?.revenues}
					timeout="auto"
					unmountOnExit
				>
					<List component="div" disablePadding>
						<ListItem button className={classes.links} disabled>
							<ListItemIcon className={classes.icon}>
								<PermContactCalendarIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('clients')}
							/>
						</ListItem>
						<ListItem button className={classes.links} disabled>
							<ListItemIcon className={classes.icon}>
								<BusinessCenterIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('proposals')}
							/>
						</ListItem>
						<ListItem button className={classes.links} disabled>
							<ListItemIcon className={classes.icon}>
								<DescriptionIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tInvoices('invoices')}
							/>
						</ListItem>
					</List>
				</Collapse>
				<Divider className={classes.divider} />
				<ListItem button className={classes.links} disabled>
					<ListItemIcon className={classes.icon}>
						<AccountBalanceIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText className={classes.text} primary="Banking" />
				</ListItem>
				<Divider className={classes.divider} />
				<ListItem button className={classes.links} disabled>
					<ListItemIcon className={classes.icon}>
						<AssessmentIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						className={classes.text}
						primary="Reporting"
					/>
				</ListItem>
				<Divider className={classes.divider} />

				<ListItem
					button
					style={{ paddingLeft: '2rem', marginTop: '1rem' }}
					disabled
				>
					<ListItemText
						className={classes.text}
						primary={tMenuDrawer('settings')}
					/>
					{openDropdown?.settings ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse
					in={openDropdown?.settings}
					timeout="auto"
					unmountOnExit
				>
					<List component="div" disablePadding>
						<ListItem
							button
							className={classes.links}
							onClick={() => navigate('/accountSettings')}
						>
							<ListItemIcon className={classes.icon}>
								<SettingsIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('accountSettings')}
							/>
						</ListItem>
						<ListItem button className={classes.links} disabled>
							<ListItemIcon className={classes.icon}>
								<SettingsIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								className={classes.text}
								primary={tMenuDrawer('teamSettings')}
							/>
						</ListItem>
					</List>
				</Collapse>
				<Divider className={classes.divider} />
			</List>
		</div>
	)

	return (
		<div>
			<React.Fragment>
				<MenuIcon
					onClick={toggleDrawer('left', true)}
					style={{ marginRight: '1rem', cursor: 'pointer' }}
				/>
				<Drawer
					anchor={'left'}
					open={open || isMenuDrawerOpen}
					onClose={toggleDrawer('left', false)}
					PaperProps={{
						style: {
							display: 'flex',
						},
						className: 'menuDrawer',
					}}
					ModalProps={{
						style: {
							zIndex: 2000,
						},
					}}
				>
					<div className={classes.header}>
						<img
							src={ChedarLogo}
							alt="Chedar Logo"
							className={classes.logoImage}
						/>
						<ArrowBackIcon
							className={classes.backArrow}
							onClick={toggleDrawer('left', false)}
							fontSize="small"
						/>
					</div>

					<TextField
						placeholder="Search"
						variant="outlined"
						size="small"
						className={classes.searchBar}
						disabled
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon fontSize="medium" />
								</InputAdornment>
							),
						}}
						InputLabelProps={{
							shrink: 'false',
						}}
					/>

					<Divider className={classes.divider} />
					{userLoginStatus && isCompanyAdmin && companyAdminList()}
					{userLoginStatus && isFreelancer && freelancerList()}
					{userLoginStatus && isTeamOrSubTeamAdmin && teamAdminList()}
				</Drawer>
			</React.Fragment>
		</div>
	)
}
